module.exports = __webpack_public_path__ + "static/media/animation-screen-colored.9d3ed674.svg";